import dashboard from './dashboard';
import facilities from './facilities';
import completeness from './completeness';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, facilities, completeness]
};

export default menuItems;
